/* eslint-disable no-param-reassign */

// const state = {
//   year: null,
//   month: null,
//   date: null,
// };

// const mutations = {
//   updateMonthYear(state, { year, month }) {
//     console.log("updateMonthYear", year, month);
//     if (month !== null) {
//       state.month = month;
//     }
//     if (year !== null) {
//       state.year = year;
//     }
//   },
//   updateDate(state, { year, month, date }) {
//     state.date = {
//       year,
//       month,
//       date,
//     };
//   },
// };

// const getters = {
//   year: state => state.year,
//   month: state => state.month,
//   date: state => state.date,
// };

export default {
  state: {
    year: null,
    month: null,
    date: null,
  },
  mutations: {
    updateMonthYear(state, { year, month }) {
      if (month !== null) {
        state.month = month;
      }
      if (year !== null) {
        state.year = year;
      }
    },
    updateDate(state, { year, month, date }) {
      state.date = {
        year,
        month,
        date,
      };
    },
  },
  getters: {
    year: state => state.year,
    month: state => state.month,
    date: state => state.date,
  },
};



// WEBPACK FOOTER //
// ./src/store/calendar.js